import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export const publishCreateStageDeletedEvent = (data: { caseType: string }) => {
  /* publish create stage info for case tracking */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.CASE_EVENTS.CREATE_STAGE_DELETED, data);
};

export default {
  publishCreateStageDeletedEvent
};
